<template>
  <div class="layout-left">
    <el-menu  class="el-menu-vertical-demo" :unique-opened="true" :default-openeds="openeds"
             :collapse="isCollapse">
      <menu-tree :menuList="routes"></menu-tree>
    </el-menu>
  </div>
</template>

<script>

	import MenuTree from './menuTree'
    import * as util from '@/assets/js/util.js';
	export default {
		name: "sidebar",
		components: {
			MenuTree
		},
		data() {
			return {
				isCollapse: false,
                openeds:[]
			};
		},

		computed: {
			routes() {
				return this.$store.state.menuList
			}
		},
        watch:{
            $store:function (){
                if (this.$store.state.meunuListChange=='YES'){
                    this.reload();
                    util.session('menuListIsChange','NO');
                    this.$store.dispatch('setMenuListChange', 'NO');
                }
            }
        },
        created() {
            /*let businessType=util.session('businessType');
            if(businessType=='2'){
                this.openeds=['20230423142543631507733731868672']
            }else if(businessType=='3'){
                this.openeds=['20230423102451631447116660604928']
            }else if(businessType=='4'){
                this.openeds=['20230423102435631447048679325696']
            }else if(businessType=='1'){
                // this.isCollapse=true;
                // this.openeds=['20230423102309631446687746883584','20230423102334631446791237140480','20230228204847612035187894648832']
            }*/
            this.openeds=['2026011122324564342991843837158621184','2026010216042921710988484634088046592','20260522161244947421039221014501785600']
        }
	}
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  background-color: #06497D;
}
.layout-left {
  display: inline-block;
  text-align: left;
  height: 100%;
  background-color: #06497D;
}

.el-menu-item.is-active {
  color: #303133;
}
/*.el-menu-vertical-demo {*/
/*  background-color: #06497D;*/
/*}*/
.router-link-active > li {
  color: #409EFF;
}

.router-link-active > .el-menu-item.is-active {
  color: #409EFF;
}
</style>